import { render } from "./MethodSection.vue?vue&type=template&id=3eaaf7be&scoped=true"
import script from "./MethodSection.vue?vue&type=script&lang=js"
export * from "./MethodSection.vue?vue&type=script&lang=js"

import "./MethodSection.vue?vue&type=style&index=0&id=3eaaf7be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eaaf7be"]])

export default __exports__